import {
  http,
  delay,
  HttpResponse,
} from 'msw';

import { createMockEndpoint } from '@/mocks/create-mock-endpoint';
import { PhysicalPrepaidCardSettingResponse } from '@/repositories/generated';

const response: PhysicalPrepaidCardSettingResponse = { menuDisplayFlag: true };

export const physicalPrepaidCardSetting = http.get(
  createMockEndpoint('/physical_prepaid_card_setting'),
  async () => {
    await delay(500);
    return HttpResponse.json(response, { status: 200 });
  },
);
